import { takeLatest } from 'redux-saga'
import { put, select } from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import flipgridActions from 'redux/actions/flipgridActions'
import {flipgridSync} from 'sync'
import flipgridSaveSelector from 'redux/selectors/flipgrid/flipgrid_creation_tool_save_selector'

import callAny from './helpers/call_any'
import formatError from './helpers/error_formatter'

function *creationToolInitialize(action) {
	try {
		const flipgridData = yield callAny(flipgridSync.getSlide,
			action.flipgridUID)
		yield put(flipgridActions.initializeSuccess(
			flipgridData.payload.flipgrid
		))
	} catch (error) {
		const serverError = formatError(error)
		yield put(flipgridActions.initializeError(serverError))
	}
}

function *creationToolSave() {
	const saveData = yield select(flipgridSaveSelector)
	try {
		yield callAny(flipgridSync.saveSlide,
			saveData.entityUid,
			saveData.teacherUrl,
			saveData.studentUrl,
		)
		yield put(flipgridActions.saveCreationSuccess())
	} catch (error) {
		const serverError = formatError(error)
		yield put(flipgridActions.saveCreationError(serverError))
	}
}

export default [
	takeLatest(
		[
			actionTypes.FLIPGRID_CREATION_TOOL_INITIALIZE,
			actionTypes.FLIPGRID_INITIALIZE_STANDALONE,
		],
		creationToolInitialize
	),
	takeLatest(actionTypes.FLIPGRID_CREATION_TOOL_SAVE,
		creationToolSave),
]

export {
	creationToolInitialize,
	creationToolSave,
}
